export function logFormSubmitEvent(formId: string) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'marketo-formSubmission',
    'gtm.elementId': formId, // Form ID variable
    formName: formId,
    formSuccess: true,
  });
}
